// Mock content for the Planimex clone (frontend-only).
// All copy is the exact Romanian text from the source site.

export const IMAGES = {
  methodology:
    'https://static.prod-images.emergentagent.com/jobs/1711381a-d205-4d1e-8dd6-2743a9ad5c10/images/77ac7e5d87c407da843032e9c20f6dbb889d15acf7d97b73f7396c7848299a89.jpeg',
  services:
    'https://static.prod-images.emergentagent.com/jobs/1711381a-d205-4d1e-8dd6-2743a9ad5c10/images/83b37a472f6687601b7085e8d9fb83d8fb0444aa5aaa0ff6ff4d2dbabf4ec08f.jpeg',
};

export const NAV_LINKS = [
  { label: 'METODOLOGIE', href: '#metodologie' },
  { label: 'SERVICII', href: '#servicii' },
  { label: 'PORTFOLIO', href: '/portfolio' },
  { label: 'CONTACT', href: '#contact' },
];

export const HERO = {
  eyebrow: 'Antrepriză generală în construcții',
  title: 'Think. Plan. Deliver.',
  tagline: ['THINK', 'PLAN', 'DELIVER'],
  description:
    'Fiecare proiect începe cu o analiză atentă și se încheie cu o execuție de calitate. Soluții fundamentate, costuri transparente, rezultate la standarde ridicate.',
  cta: 'DESCOPERĂ METODOLOGIA',
};

export const METHODOLOGY = {
  label: '/ METODOLOGIE',
  heading: 'THINK – PLAN – DELIVER',
  intro:
    'La Planimex, fiecare proiect începe cu o analiză atentă și se încheie cu o execuție de calitate. Metodologia noastră Gândim – Planificăm – Livrăm ne permite să oferim soluții bine fundamentate, costuri transparente și rezultate livrate la standarde ridicate.',
  steps: [
    {
      num: '01',
      title: 'GÂNDIM',
      text: 'Înțelegem proiectul înainte de a începe orice lucrare. Analizăm cerințele, identificăm provocările și propunem cele mai eficiente soluții tehnice și economice pentru investiția dumneavoastră.',
    },
    {
      num: '02',
      title: 'PLANIFICĂM',
      text: 'Planificarea riguroasă este cheia unui proiect reșit. Realizăm ofertarea completă, estimăm costurile pentru materiale și manoperă și stabilim un plan clar de implementare, astfel încât fiecare etapă să fie bine organizată.',
    },
    {
      num: '03',
      title: 'LIVRĂM',
      text: 'Punem planul în practică printr-o execuție atent coordonată. Respectăm termenele asumate, monitorizăm permanent calitatea lucrărilor și livrăm proiecte conforme cu cerințele beneficiarului.',
    },
  ],
};

export const MARQUEE_WORDS = ['THINK', 'PLAN', 'DELIVER'];

export const SERVICES = {
  label: '/ SERVICII',
  heading: 'CE OFERIM',
  groups: [
    {
      roman: 'I',
      title: 'CONSULTANȚĂ TEHNICĂ',
      items: [
        {
          num: '01',
          title: 'Gestionare buget',
          text: 'Monitorizăm permanent costurile proiectului pentru a ne asigura că investiția rămâne în limitele bugetului stabilit. Urmărim eficient cheltuielile și propunem soluții care optimizează raportul dintre cost și calitate.',
        },
        {
          num: '02',
          title: 'Management proiect',
          text: 'Coordonăm proiectul de la planificarea inițială până la urmărirea etapelor de execuție, astfel încât fiecare activitate să fie bine organizată, predictibilă și desfășurată conform obiectivelor stabilite.',
        },
      ],
    },
    {
      roman: 'II',
      title: 'SERVICII DE CONSTRUCȚII',
      items: [
        {
          num: '01',
          title: 'Structură',
          text: 'Executăm lucrări de structură pentru construcții rezidențiale, comerciale și industriale, respectând proiectul tehnic și standardele actuale de calitate și siguranță.',
        },
        {
          num: '02',
          title: 'Instalații',
          text: 'Realizăm instalații electrice, sanitare și termice, adaptate cerințelor fiecărui proiect și executate conform normelor tehnice în vigoare.',
        },
        {
          num: '03',
          title: 'Lucrări de finisare',
          text: 'Oferim servicii complete de finisaje interioare și exterioare, punând accent pe calitatea execuției și atenția la detalii pentru un rezultat estetic și durabil.',
        },
        {
          num: '04',
          title: 'Sistematizare exterioară',
          text: 'Amenajăm spațiile exterioare astfel încât acestea să fie funcționale, bine organizate și integrate armonios în ansamblul construcției.',
        },
        {
          num: '05',
          title: 'Mentenanță',
          text: 'Asigurăm servicii de mentenanță și intervenții pentru menținerea construcțiilor în stare optimă de funcționare, contribuind la prelungirea duratei lor de viață și la reducerea costurilor de exploatare.',
        },
      ],
    },
  ],
};

export const CONTACT = {
  label: '/ CONTACT',
  headingLines: ['PROIECTUL', 'DUMNEAVOASTRĂ', 'MERITĂ'],
  intro:
    'Proiectul dumneavoastră merită un partener de încredere. Contactați-ne astăzi pentru a discuta noul dumneavoastră proiect!',
  email: 'office@planimex.ro',
  phone: '+40 720 002 680',
  form: {
    name: 'NUME',
    namePlaceholder: 'Numele dumneavoastră',
    email: 'EMAIL',
    emailPlaceholder: 'adresa@email.com',
    phone: 'TELEFON (OPȚIONAL)',
    phonePlaceholder: '+40 ...',
    message: 'MESAJ',
    messagePlaceholder: 'Descrieți pe scurt proiectul dumneavoastră...',
    submit: 'TRIMITE SOLICITAREA',
  },
};

export const PORTFOLIO_PROJECTS = [
  {
    title: 'Complex rezidențial premium',
    category: 'Rezidențial',
    location: 'București, Sector 1',
    year: '2024',
    client: 'Client privat',
    description: 'Amenajare completă și management de proiect pentru un ansamblu rezidențial cu standarde ridicate de calitate, execuție și experiență de utilizare.',
    metrics: ['120 unități', '18 luni', '100% conformitate'],
    services: ['Consultanță tehnică', 'Management de proiect', 'Execuție finisaje'],
    highlights: ['Coordonare între arhitectură și antreprenori', 'Control strict al bugetului și termenelor', 'Finisaje de nivel premium'],
    images: [
      'https://images.unsplash.com/photo-1511818966892-d7d671e672a2?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1200&q=80',
    ],
  },
  {
    title: 'Centru logistic industrial',
    category: 'Industrial',
    location: 'Ploiești, județul Prahova',
    year: '2023',
    client: 'Operator logistic',
    description: 'Coordonare tehnică și execuție pentru o investiție logistică cu cerințe complexe de eficiență, siguranță și fluxuri operaționale.',
    metrics: ['25.000 m²', '4 etape', 'Optimizare costuri'],
    services: ['Studii tehnice', 'Management investiție', 'Lucrări structurale'],
    highlights: ['Planificare etapizată pentru activitate continuă', 'Reducerea costurilor de operare', 'Soluții de siguranță conforme'],
    images: [
      'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1200&q=80',
    ],
  },
  {
    title: 'Birouri și spații comerciale',
    category: 'Comercial',
    location: 'Timișoara, județul Timiș',
    year: '2025',
    client: 'Companie de retail',
    description: 'Proiectare și implementare pentru spații moderne, adaptate cerințelor operaționale și experienței utilizatorilor.',
    metrics: ['8.500 m²', '2 luni planificare', 'Execuție la timp'],
    services: ['Amenajare interioară', 'Instalații', 'Finisaje premium'],
    highlights: ['Concept interior orientat pe experiența clientului', 'Coordonare rapidă a echipelor', 'Ritm de execuție foarte bun'],
    images: [
      'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80',
    ],
  },
  {
    title: 'Reabilitare clădire administrativă',
    category: 'Reabilitare',
    location: 'Cluj-Napoca, județul Cluj',
    year: '2022',
    client: 'Instituție publică',
    description: 'Reabilitare completă a unei clădiri administrative cu obiectivul de a îmbunătăți funcționalitatea, siguranța și estetica spațiului.',
    metrics: ['6.200 m²', '12 luni', 'Modernizare integrală'],
    services: ['Reabilitare structurală', 'Instalații noi', 'Amenajare modernă'],
    highlights: ['Minimizarea întreruperilor în activitatea instituției', 'Soluții eficiente pentru eficiență energetică', 'Livrare la standarde înalte'],
    images: [
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80',
    ],
  },
];

export const FOOTER = {
  copyright: '© 2026 PLANIMEX | THINK PLAN DELIVER',
  links: [
    { label: 'METODOLOGIE', href: '#metodologie' },
    { label: 'SERVICII', href: '#servicii' },
    { label: 'CONTACT', href: '#contact' },
    { label: 'PORTFOLIO', href: '/portfolio' },
  ],
};
